import "./aho2-content.styles.scss";
import {
  handleSignInSubmit,
  handleChange,
  signInInitial,
} from "../ah1/ah1.utils";
import { useState } from "react";
import AffiliateModal from "../affiliateModal/affiliateModal.component";
const AHO2Content = () => {
  const [signinFields, setSignInFields] = useState(signInInitial);
  const [loaderClass, setLoaderClass] = useState("aho1-loader-hidden");
  const { email, password } = signinFields;
  const [modalClass, setModalClass] = useState("aho2-affiliate-hidden");
  const [accountType, setAccountType] = useState("");
  const handleClick = (type) => {
    setAccountType(type);
    if (modalClass === "aho2-affiliate-hidden") {
      setModalClass("aho2-affiliate-view");
    } else {
      setModalClass("aho2-affiliate-hidden");
    }
  };
  return (
    <div className="aho2-content-container">
      <div className={loaderClass}>
        <div className="loader"></div>
      </div>
      <div className={modalClass}>
        <span className="aho2-modal-goback" onClick={() => handleClick("")}>
          GO BACK
        </span>

        <AffiliateModal accountTypeValue={accountType} />
      </div>
      <div className="aho2-admin-signin">
        <form
          onSubmit={(event) =>
            handleSignInSubmit(event, signinFields, setLoaderClass)
          }
          className="aho2-signin-form"
        >
          <input
            type="text"
            name="email"
            value={email}
            placeholder="E-mail or Phone"
            onChange={(event) =>
              handleChange(event, signinFields, setSignInFields, setLoaderClass)
            }
            className="aho2-input"
          />
          <input
            type="password"
            name="password"
            value={password}
            placeholder="Password"
            onChange={(event) =>
              handleChange(event, signinFields, setSignInFields)
            }
            className="aho2-input"
          />
          <button type="submit" className="aho2-submit">
            Admin Sign-In
          </button>
        </form>
      </div>
      <div className="aho2-accounts-buttons">
        <span
          className="aho2-accounts-link"
          onClick={() => handleClick("Host")}
        >
          Host Sign-in
        </span>
        <span
          className="aho2-accounts-link"
          onClick={() => handleClick("Kitchen")}
        >
          Kitchen Sign-In
        </span>
      </div>
    </div>
  );
};
export default AHO2Content;
